import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";
import {
  EquipamentoPacDetail,
  EquipamentoPacEdit,
  EquipamentoPacForm,
  FabricanteEquipamentoPac,
  HistoricoSincronismoEquipamentoPac,
  LogOperacaoEquipamentoPac,
  ModeloEquipamentoPac,
  ResultadoCadastroEquipamentoPac,
  ResultadoTesteConexao
} from "app/pages/full-pages/equipamento-pac/equipamento-pac.models";

export abstract class AbEquipamentoPac extends AppService {
  abstract prefixo: string;

  abstract criar(form: EquipamentoPacForm): Observable<ResultadoCadastroEquipamentoPac>;
  abstract testarConexao(id: number): Observable<ResultadoTesteConexao>;
  abstract listarFabricantes(): Observable<FabricanteEquipamentoPac[]>;
  abstract listarModelos(fabricanteId: number): Observable<ModeloEquipamentoPac[]>;
  abstract listar(filter: AppFilter): Observable<any>;
  abstract buscarPorId(id: number): Observable<EquipamentoPacDetail>;
  abstract editar(id: number, form: EquipamentoPacEdit): Observable<EquipamentoPacDetail>;
  abstract alterarStatus(id: number, ativo: boolean): Observable<EquipamentoPacDetail>;
  abstract excluir(id: number): Observable<any>;
  abstract sincronizar(id: number): Observable<any>;
  abstract sincronizarTodos(): Observable<any>;
  abstract resetarUsuarios(id: number): Observable<any>;
  abstract historicoSincronismo(id: number): Observable<HistoricoSincronismoEquipamentoPac>;
  abstract listarLogOperacoes(id: number): Observable<LogOperacaoEquipamentoPac[]>;
}
